import logo from '../assets/dentotek-logo.webp';

function Footer() {
    return (
        <footer className="py-6 px-4 border-t border-slate-200 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
                <div className="flex items-center gap-2">
                    <a href={"/"}>
                        <img src={logo} alt="" width={'130px'} height={'20px'}/>
                    </a>
                </div>
{/*                <div className="flex gap-8 text-sm font-medium text-slate-500">
                    <a href="#" className="hover:text-primary transition-colors">Politique de confidentialité</a>
                    <a href="#" className="hover:text-primary transition-colors">Mentions légales</a>
                    <a href="#" className="hover:text-primary transition-colors">Tarifs</a>
                </div>*/}
                <p className="text-sm text-slate-400">© {new Date().getFullYear()} DentoTek.</p>
            </div>
        </footer>
    );
}

export default Footer;